"use client"

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { useRateLimit } from "@/lib/context/rate-limit-context"
import { AlertCircle, Clock } from "lucide-react"
import { useEffect, useState } from "react"

export const RateLimitModal = () => {
    const { isRateLimited, retryAfter } = useRateLimit()
    const [countdown, setCountdown] = useState<number | null>(null)

    useEffect(() => {
        if (isRateLimited && retryAfter) {
            setCountdown(retryAfter)
            const interval = setInterval(() => {
                setCountdown((prev) => {
                    if (prev === null || prev <= 1) {
                        clearInterval(interval)
                        return 0
                    }
                    return prev - 1
                })
            }, 1000)

            return () => clearInterval(interval)
        } else {
            setCountdown(null)
        }
    }, [isRateLimited, retryAfter])

    const formatTime = (seconds: number) => {
        const mins = Math.floor(seconds / 60)
        const secs = seconds % 60
        if (mins > 0) {
            return `${mins}m ${secs}s`
        }
        return `${secs}s`
    }

    return (
        <Dialog open={isRateLimited} onOpenChange={() => { }}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="p-2 rounded-full bg-orange-500/10">
                            <AlertCircle className="h-5 w-5 text-orange-500" />
                        </div>
                        <DialogTitle>Too Many Requests</DialogTitle>
                    </div>
                    <DialogDescription className="text-left pt-2">
                        You&apos;ve made too many requests. Please wait a moment before trying again.
                    </DialogDescription>
                </DialogHeader>
                <div className="flex items-center gap-2 text-sm text-muted-foreground py-4">
                    <Clock className="h-4 w-4" />
                    {countdown !== null && countdown > 0 ? (
                        <span>Please wait {formatTime(countdown)} before making another request.</span>
                    ) : (
                        <span>Please wait a moment before making another request.</span>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    )
}

